/** @jsx jsx */
// @ts-check

export default function locationHierarchy({ brand }) {
  if (brand.countryCode === 'at') return [brand.city];
  return [brand.countryName, brand.city];
}
